(function () {
  'use strict';

  function initializeSampleBoxes() {
    document.querySelectorAll('[data-sample-box-upsell]').forEach(function (card) {
      if (card.dataset.sampleBoxReady) return;
      var form = card.querySelector('[data-sample-box-form]');
      var button = card.querySelector('button[type="submit"]');
      var status = card.querySelector('[data-sample-box-status]');
      var variantData = card.querySelector('[data-sample-box-variant]');
      if (!form || !button || !status || !variantData) return;
      var variant;
      try { variant = JSON.parse(variantData.textContent); } catch (error) { return; }
      if (!variant || !variant.id) return;
      card.dataset.sampleBoxReady = 'true';

      form.addEventListener('submit', async function (event) {
        event.preventDefault();
        if (form.dataset.pending === 'true') return;
        form.dataset.pending = 'true';
        button.disabled = true;
        card.setAttribute('aria-busy', 'true');
        status.hidden = false;
        status.textContent = card.dataset.adding;
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        try {
          var response = await fetch(form.dataset.addUrl, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: variant.id, quantity: 1 })
          });
          var data = await response.json();
          if (!response.ok) {
            status.textContent = typeof data.description === 'string' ? data.description : card.dataset.error;
            return;
          }
          status.textContent = card.dataset.added;
          card.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: variant, quantity: 1 }
          }));
        } catch (error) {
          status.textContent = card.dataset.error;
        } finally {
          form.dataset.pending = 'false';
          button.disabled = false;
          card.removeAttribute('aria-busy');
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSampleBoxes, { once: true });
  } else {
    initializeSampleBoxes();
  }
  document.addEventListener('shopify:section:load', initializeSampleBoxes);
}());
